import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import UserFormCard from '../components/UserFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class AddUserScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.USERS,
            Breadcrumbs.USERS_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_NUEVO_USUARIO')} breadcrumbs={breadcrumbs}>
                <UserFormCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/users/screens/AddUserScreen.jsx